module.exports = __webpack_public_path__ + "img/logo_1.f7d987ce.png";